module.exports = __webpack_public_path__ + "img/LTS_NP.05ced179.gif";